if (!customElements.get('alphex-installments')) {
  customElements.define('alphex-installments', class extends HTMLElement {
    connectedCallback() {
      this.form = document.forms[this.getAttribute('form')];
      this.count = Number(this.dataset.count);
      this.formatter = new Intl.NumberFormat(this.dataset.locale || document.documentElement.lang, {
        style: 'currency',
        currency: this.dataset.currency
      });
      this.onVariantChange = (event) => {
        const variant = event.detail.variant;
        this.hidden = !variant || !variant.available;
        if (!this.hidden && this.count > 0) {
          this.querySelector('[data-installment-value]').textContent = this.formatter.format(Math.round(variant.price / this.count) / 100);
        }
      };
      this.form?.addEventListener('variant:change', this.onVariantChange);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('variant:change', this.onVariantChange);
    }
  });
}
